import React, { ReactNode, useLayoutEffect, useRef, useState } from "react";
import Marquee from "react-fast-marquee";

const ConditionalMarquee = ({ children }: { children: ReactNode }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    if (containerRef.current && contentRef.current) {
      const containerWidth = containerRef.current?.offsetWidth;
      const contentWidth = contentRef.current?.scrollWidth;

      setIsOverflowing(contentWidth > containerWidth);
    }
  }, [children]);

  return (
    <div
      ref={containerRef}
      style={{ overflow: "hidden", whiteSpace: "nowrap" }}
    >
      {/* Hidden div for measurement */}
      <div
        ref={contentRef}
        style={{
          visibility: "hidden",
          position: "fixed",
          top: "-9999px",
          left: "-9999px",
          whiteSpace: "nowrap",
        }}
      >
        {children}
      </div>
      {isOverflowing ? (
        <Marquee pauseOnHover>{children}</Marquee>
      ) : (
        <div>{children}</div>
      )}
    </div>
  );
};

export default ConditionalMarquee;
